import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarAlt, FaSpinner } from "react-icons/fa";

function BookMeetingModal({ isOpen, closeModal }) {
  const [step, setStep] = useState(1);
  const [city, setCity] = useState("");
  // const [date, setDate] = useState("");
  const [date, setDate] = useState(null);
  const [time, setTime] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const timeSlots = [
"10:00 AM",
"11:00 AM",
"12:00 PM",
"01:00 PM",
"02:00 PM",
"03:00 PM",
"04:00 PM",
"05:00 PM"
];

const formatLocalDate = (value) => {
  if (!value) return "";

  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const fetchSlots = (selectedDate) => {

  fetch(`https://dwellorahomes.com/get_booked_slots.php?date=${selectedDate}`)
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data)) {
        setBookedSlots(data);
      } else {
        setBookedSlots([]);
      }
    })
    .catch(() => setBookedSlots([]));

};

  const [bookedSlots, setBookedSlots] = useState([]);
useEffect(() => {

  if(!date) return;

  setTime("");

  fetchSlots(
    formatLocalDate(date)
  );

  const interval = setInterval(() => {
fetchSlots(
  formatLocalDate(date)
);
  }, 5000);

  return () => clearInterval(interval);

}, [date]);

  const phoneRegex = /^[6-9]\d{9}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";

    return () => (document.body.style.overflow = "auto");
  }, [isOpen]);

 const resetForm = () => {
  setCity("");
  setDate(null);
  setTime("");
  setName("");
  setPhone("");
  setEmail("");
  setError("");
  setBookedSlots([]);
  setStep(1);
  setIsSubmitting(false);
};

  if (!isOpen) return null;

  const nextStep = () => {
    if (step === 1 && !city) {
      setError("Please select city");
      return;
    }

    if (step === 2 && (!date || !time)) {
      setError("Select date and time");
      return;
    }

    setError("");
    setStep(step + 1);
  };

  const prevStep = () => {
    setError("");
    setStep(step - 1);
  };

//   const handleSubmit = async () => {
//     if (!name || !phone) {
//       setError("Fill all details");
//       return;
//     }

//     if (!phoneRegex.test(phone)) {
//       setError("Enter valid 10 digit mobile number");
//       return;
//     }

//     setError("");



const handleSubmit = async () => {
  if (!name || !phone || !email) {
    setError("Fill all details");
    return;
  }

  if (!phoneRegex.test(phone)) {
    setError("Enter valid 10 digit mobile number");
    return;
  }

  if (!emailRegex.test(email)) {
    setError("Enter valid email address");
    return;
  }

  setError("");
  setIsSubmitting(true);

      try {
      const res = await fetch("https://dwellorahomes.com/process_booking.php", {

        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
//       body: JSON.stringify({
//   city,
//   date: date
//     ? date.toISOString().split("T")[0]
//     : "",
//   time,
//   name,
//   phone
// })
//       });


body: JSON.stringify({
  city,
  date: formatLocalDate(date),
  time,
  name,
  phone,
  email
})
    });

      const data = await res.json();

      console.log("Booking API response:", data);

      if (data.status === "slot_taken") {
        setError("This time slot is already booked");
        setIsSubmitting(false);
        return;
      }

     if (data.status === "success") {

fetchSlots(
  formatLocalDate(date)
);

  setIsSubmitting(false);
  setSuccess(true);

        const message = `Hello ${name},

Your meeting has been successfully booked

 City: ${city}
Date: ${
  date
    ? date.toLocaleDateString("en-US")
    : ""
}
 Time: ${time}

Our team will contact you shortly.

\u2014 Dwellora Homes
 +91 9158914222
 WhatsApp: https://wa.me/919158914222
Instagram: https://www.instagram.com/dwellora.homes/
`;
       window.open(
  `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`,
  "_blank"
);

        setTimeout(() => {
          setSuccess(false);
          resetForm();
          closeModal();
        }, 3000);
      }
    } catch (err) {
      console.log("Booking request failed:", err);
      setError("Something went wrong");
      setIsSubmitting(false);
    }
  };


  return (
    <div className="wizard-overlay">
      <style>{`
        .spinner-icon {
          animation: wizard-spin 0.8s linear infinite;
          margin-right: 6px;
          vertical-align: middle;
        }
        @keyframes wizard-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
      <div className="wizard-modal">

        <button
          className="wizard-close"
          onClick={() => {
            resetForm();
            closeModal();
          }}
        >
          ×
        </button>

        {!success ? (
          <>
            <div className="wizard-progress">
              <div className={`progress-dot ${step >= 1 ? "active" : ""}`}></div>
              <div className={`progress-dot ${step >= 2 ? "active" : ""}`}></div>
              <div className={`progress-dot ${step >= 3 ? "active" : ""}`}></div>
            </div>

            {error && <p className="error-text">{error}</p>}

            {step === 1 && (
              <div className="wizard-step">
                <h3>Select Your City</h3>

                <div className="select-wrapper">
  <select
    className="wizard-input"
    value={city}
    onChange={(e) => setCity(e.target.value)}
  >
    <option value="">Choose city</option>

    <option>Pune</option>
    <option>Nashik</option>
    <option>Latur</option>
    <option>Sambhaji Nagar</option>
  </select>
</div>

                {/* <select
                  className="wizard-input"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                >
                  <option value="">Choose city</option>
                  <option>Mumbai</option>
                  <option>Pune</option>
                  <option>Nashik</option>
                  <option>Latur</option>
                  <option>Sambhaji Nagar</option>
                </select> */}

             <button
className={`wizard-btn ${!city ? "disabled" : ""}`}
disabled={!city}
onClick={nextStep}
>

                  Continue
                </button>
              </div>
            )}

            {step === 2 && (
              <div className="wizard-step">
                <h3>Select Date</h3>

             <div className="date-picker-wrapper">
  <DatePicker
    selected={date}
    onChange={(selectedDate) => {
      setDate(selectedDate);
      setTime("");
    }}
    minDate={new Date()}
    placeholderText="mm/dd/yyyy"
    dateFormat="MM/dd/yyyy"
    className="wizard-input"
  />

  <FaRegCalendarAlt className="calendar-icon" />
</div>

                <h4>Select Time Slot</h4>

 <div className="time-grid">
{timeSlots.map((slot)=>{

const isBooked = bookedSlots.includes(slot);

const now = new Date();
const selectedDate = new Date(date);

let isPast = false;

if(selectedDate.toDateString() === now.toDateString()){

const slotHour = parseInt(slot.split(":")[0]);
const isPM = slot.includes("PM");

let hour24 = slotHour;

if(isPM && slotHour !== 12) hour24 += 12;
if(!isPM && slotHour === 12) hour24 = 0;

// if(hour24 < now.getHours()){
// isPast = true;
// }

const slotDateTime = new Date(selectedDate);
slotDateTime.setHours(hour24, 0, 0, 0);

if (slotDateTime <= now) {
  isPast = true;
}

}

return(

<div
key={slot}
className={`time-box
${time === slot ? "active" : ""}
${isBooked || isPast ? "disabled" : ""}`}
onClick={()=>!(isBooked || isPast) && setTime(slot)}
>
{slot}
</div>

)

})}
</div>

                <div className="wizard-actions">
                  <button className="wizard-back" onClick={prevStep}>
                    Back
                  </button>
                <button
className={`wizard-btn ${!date || !time ? "disabled" : ""}`}
disabled={!date || !time}
onClick={nextStep}
>
                    Continue
                  </button>
                </div>
              </div>
            )}

            {/* {step === 3 && (
              <div className="wizard-step">
                <h3>Your Contact Details</h3>

                <input
                  type="text"
                  placeholder="Full Name *"
                  className="wizard-input"
                  value={name}
               onChange={(e) => {
  const value = e.target.value;
  if (/^[A-Za-z ]*$/.test(value)) {
    setName(value);
  }
}}
                />

                <input
                  type="tel"
                  placeholder="Phone Number *"
                  className="wizard-input"
                  value={phone}
                 onChange={(e) => {
  const value = e.target.value;
  if (/^[0-9]*$/.test(value) && value.length <= 10) {
    setPhone(value);
  }
}}
                />

                <div className="wizard-actions">
                  <button className="wizard-back" onClick={prevStep}>
                    Back
                  </button>
                  <button className="wizard-btn" onClick={handleSubmit}>
                    Confirm Booking
                  </button>
                </div>
              </div>
            )} */}

{step === 3 && (
  <div className="wizard-step">
    <h3>Your Contact Details</h3>

    <input
      type="text"
      placeholder="Full Name *"
      className="wizard-input"
      value={name}
      onChange={(e) => {
        const value = e.target.value;

        if (/^[A-Za-z ]*$/.test(value)) {
          setName(value);
        }
      }}
    />

    <input
      type="tel"
      placeholder="Phone Number *"
      className="wizard-input"
      value={phone}
      onChange={(e) => {
        const value = e.target.value;

        if (/^[0-9]*$/.test(value) && value.length <= 10) {
          setPhone(value);
        }
      }}
    />

    <input
      type="email"
      placeholder="Email Address *"
      className="wizard-input"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
    />

    <div className="wizard-actions">
      <button
        className="wizard-back"
        onClick={prevStep}
      >
        Back
      </button>

      <button
        className={`wizard-btn ${isSubmitting ? "disabled" : ""}`}
        onClick={handleSubmit}
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <FaSpinner className="spinner-icon" /> Booking...
          </>
        ) : (
          "Confirm Booking"
        )}
      </button>
    </div>
  </div>
)}

          </>
        ) : (
          <div className="success-box">
            <div className="checkmark">{"\u2713"}</div>
            <h3>Booking Confirmed</h3>
            <p>Details sent successfully</p>
          </div>
        )}

      </div>
    </div>
  );
}

export default BookMeetingModal;